export default "__VITE_ASSET__848d811c__"